module.exports = __webpack_public_path__ + "static/media/backarrow1.b2555636.png";